import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

export function usePage(key) {
  const [state, setState] = useState({ loading: true, sections: {} });
  useEffect(() => {
    let live = true;
    setState({ loading: true, sections: {} });
    api
      .get(`/content/${key}`)
      .then((r) => live && setState({ loading: false, sections: r.data.sections || {} }))
      .catch(() => live && setState({ loading: false, sections: {} }));
    return () => {
      live = false;
    };
  }, [key]);
  return state;
}

export function useAreas() {
  const [areas, setAreas] = useState([]);
  useEffect(() => {
    let live = true;
    api
      .get("/areas")
      .then((r) => live && setAreas(r.data || []))
      .catch(() => {});
    return () => {
      live = false;
    };
  }, []);
  return areas;
}

export function useArticles(limit) {
  const [state, setState] = useState({ loading: true, items: [], total: 0 });
  useEffect(() => {
    let live = true;
    api
      .get("/articles", { params: { limit: limit || 24 } })
      .then((r) => live && setState({ loading: false, items: r.data.items || [], total: r.data.total }))
      .catch(() => live && setState({ loading: false, items: [], total: 0 }));
    return () => {
      live = false;
    };
  }, [limit]);
  return state;
}

const SettingsCtx = createContext({ settings: null, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const refresh = () =>
    api
      .get("/settings")
      .then((r) => setSettings(r.data))
      .catch(() => {});
  useEffect(() => {
    refresh();
  }, []);
  return <SettingsCtx.Provider value={{ settings, refresh }}>{children}</SettingsCtx.Provider>;
}

export function useSettings() {
  return useContext(SettingsCtx);
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch (e) {
    return "";
  }
}

export function splitParagraphs(text) {
  return (text || "")
    .split(/\n\s*\n|\r\n\s*\r\n/)
    .map((p) => p.trim())
    .filter(Boolean);
}
